
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire6aa4"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire6aa4"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("iqBwt", function(module, exports) {

$parcel$export(module.exports, "db", function () { return $d6a7c2f381b689be$export$f932f06c7eb6abeb; });
$parcel$export(module.exports, "auth", function () { return $d6a7c2f381b689be$export$73693bad9f5880b0; });
$parcel$export(module.exports, "storage", function () { return $d6a7c2f381b689be$export$ddcffe0146c8f882; });
// Firebase web app configuration
const $d6a7c2f381b689be$export$fcc0626890c55730 = {
    apiKey: "AIzaSyASuSpKlErBr3KzvApvaGrZy6qFLxITXws",
    authDomain: "personal-blog-72c0a.firebaseapp.com",
    projectId: "personal-blog-72c0a",
    storageBucket: "personal-blog-72c0a.firebasestorage.app",
    messagingSenderId: "1088696541263",
    appId: "1:1088696541263:web:902a8044bf6948795c8a3a",
    measurementId: "G-27ESNNTE4C"
};
let $d6a7c2f381b689be$export$729c8b7179294ba, $d6a7c2f381b689be$export$f932f06c7eb6abeb, $d6a7c2f381b689be$export$73693bad9f5880b0, $d6a7c2f381b689be$export$ddcffe0146c8f882;
if (typeof window !== "undefined" && window.firebase) {
    // Only initialize if not already initialized
    $d6a7c2f381b689be$export$729c8b7179294ba = window.firebase.apps.length ? window.firebase.app() : window.firebase.initializeApp($d6a7c2f381b689be$export$fcc0626890c55730);
    if (typeof window.firebase.firestore === "function") $d6a7c2f381b689be$export$f932f06c7eb6abeb = window.firebase.firestore();
    if (typeof window.firebase.auth === "function") $d6a7c2f381b689be$export$73693bad9f5880b0 = window.firebase.auth();
    if (typeof window.firebase.storage === "function") $d6a7c2f381b689be$export$ddcffe0146c8f882 = window.firebase.storage();
} else console.warn("Firebase SDK not found on window. Ensure Firebase scripts are loaded in the HTML page.");

});

// Import dependencies
function $879a1b32f60b3418$export$2e2bcd8739ae039(targetElements, defaultProps) {
    if (!targetElements.length) return;
    ScrollReveal({
        reset: false
    });
    targetElements.forEach(({ element: element, animation: animation })=>{
        ScrollReveal().reveal(element, Object.assign({}, defaultProps, animation));
    });
}


const $5912c15f3759d7b5$var$prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
const $5912c15f3759d7b5$export$9c21a3269931e1e6 = {
    easing: "cubic-bezier(0.5, 0, 0, 1)",
    distance: $5912c15f3759d7b5$var$prefersReducedMotion ? "0px" : "30px",
    duration: $5912c15f3759d7b5$var$prefersReducedMotion ? 0 : 800,
    desktop: true,
    mobile: true
};
const $5912c15f3759d7b5$export$adcf75ad64a03007 = [
    {
        element: ".section-title",
        animation: $5912c15f3759d7b5$var$prefersReducedMotion ? {} : {
            delay: 300,
            distance: "0px",
            origin: "bottom"
        }
    },
    {
        element: ".hero-title",
        animation: $5912c15f3759d7b5$var$prefersReducedMotion ? {} : {
            delay: 500,
            origin: window.innerWidth > 768 ? "left" : "bottom"
        }
    },
    {
        element: ".hero-cta",
        animation: $5912c15f3759d7b5$var$prefersReducedMotion ? {} : {
            delay: 1000,
            origin: window.innerWidth > 768 ? "left" : "bottom"
        }
    },
    {
        element: ".about-wrapper__image",
        animation: $5912c15f3759d7b5$var$prefersReducedMotion ? {} : {
            delay: 600,
            origin: "bottom"
        }
    },
    {
        element: ".about-wrapper__info",
        animation: $5912c15f3759d7b5$var$prefersReducedMotion ? {} : {
            delay: 1000,
            origin: window.innerWidth > 768 ? "left" : "bottom"
        }
    },
    {
        element: ".project-wrapper__text",
        animation: $5912c15f3759d7b5$var$prefersReducedMotion ? {} : {
            delay: 500,
            origin: window.innerWidth > 768 ? "left" : "bottom"
        }
    },
    {
        element: ".project-wrapper__image",
        animation: $5912c15f3759d7b5$var$prefersReducedMotion ? {} : {
            delay: 1000,
            origin: window.innerWidth > 768 ? "right" : "bottom"
        }
    },
    {
        element: ".blog-wrapper",
        animation: $5912c15f3759d7b5$var$prefersReducedMotion ? {} : {
            delay: 700,
            origin: "bottom"
        }
    },
    {
        element: ".blog-wrapper__card",
        animation: $5912c15f3759d7b5$var$prefersReducedMotion ? {} : {
            delay: 800,
            origin: window.innerWidth > 768 ? "right" : "bottom"
        }
    },
    {
        element: ".contact-wrapper",
        animation: $5912c15f3759d7b5$var$prefersReducedMotion ? {} : {
            delay: 800,
            origin: "bottom"
        }
    },
    {
        element: ".skills-wrapper",
        animation: $5912c15f3759d7b5$var$prefersReducedMotion ? {} : {
            delay: 800,
            origin: "bottom"
        }
    }
];


var $061d6f05ab78f897$exports = {};
'use strict';
var $061d6f05ab78f897$var$classCallCheck = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};
/**
 * Created by Sergiu Șandor (micku7zu) on 1/27/2017.
 * Original idea: https://github.com/gijsroge/tilt.js
 * MIT License.
 * Version 1.7.3
 */ var $061d6f05ab78f897$var$VanillaTilt = function() {
    function VanillaTilt(element) {
        var settings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        $061d6f05ab78f897$var$classCallCheck(this, VanillaTilt);
        if (!(element instanceof Node)) throw "Can't initialize VanillaTilt because " + element + " is not a Node.";
        this.width = null;
        this.height = null;
        this.clientWidth = null;
        this.clientHeight = null;
        this.left = null;
        this.top = null;
        // for Gyroscope sampling
        this.gammazero = null;
        this.betazero = null;
        this.lastgammazero = null;
        this.lastbetazero = null;
        this.transitionTimeout = null;
        this.updateCall = null;
        this.event = null;
        this.updateBind = this.update.bind(this);
        this.resetBind = this.reset.bind(this);
        this.element = element;
        this.settings = this.extendSettings(settings);
        this.reverse = this.settings.reverse ? -1 : 1;
        this.glare = VanillaTilt.isSettingTrue(this.settings.glare);
        this.glarePrerender = VanillaTilt.isSettingTrue(this.settings["glare-prerender"]);
        this.fullPageListening = VanillaTilt.isSettingTrue(this.settings["full-page-listening"]);
        this.gyroscope = VanillaTilt.isSettingTrue(this.settings.gyroscope);
        this.gyroscopeSamples = this.settings.gyroscopeSamples;
        this.elementListener = this.getElementListener();
        if (this.glare) this.prepareGlare();
        if (this.fullPageListening) this.updateClientSize();
        this.addEventListeners();
        this.reset();
        this.updateInitialPosition();
    }
    VanillaTilt.isSettingTrue = function isSettingTrue(setting) {
        return setting === "" || setting === true || setting === 1;
    };
    /**
   * Method returns element what will be listen mouse events
   * @return {Node}
   */ VanillaTilt.prototype.getElementListener = function getElementListener() {
        if (this.fullPageListening) return window.document;
        if (typeof this.settings["mouse-event-element"] === "string") {
            var mouseEventElement = document.querySelector(this.settings["mouse-event-element"]);
            if (mouseEventElement) return mouseEventElement;
        }
        if (this.settings["mouse-event-element"] instanceof Node) return this.settings["mouse-event-element"];
        return this.element;
    };
    /**
   * Method set listen methods for this.elementListener
   * @return {Node}
   */ VanillaTilt.prototype.addEventListeners = function addEventListeners() {
        this.onMouseEnterBind = this.onMouseEnter.bind(this);
        this.onMouseMoveBind = this.onMouseMove.bind(this);
        this.onMouseLeaveBind = this.onMouseLeave.bind(this);
        this.onWindowResizeBind = this.onWindowResize.bind(this);
        this.onDeviceOrientationBind = this.onDeviceOrientation.bind(this);
        this.elementListener.addEventListener("mouseenter", this.onMouseEnterBind);
        this.elementListener.addEventListener("mouseleave", this.onMouseLeaveBind);
        this.elementListener.addEventListener("mousemove", this.onMouseMoveBind);
        if (this.glare || this.fullPageListening) window.addEventListener("resize", this.onWindowResizeBind);
        if (this.gyroscope) window.addEventListener("deviceorientation", this.onDeviceOrientationBind);
    };
    /**
   * Method remove event listeners from current this.elementListener
   */ VanillaTilt.prototype.removeEventListeners = function removeEventListeners() {
        this.elementListener.removeEventListener("mouseenter", this.onMouseEnterBind);
        this.elementListener.removeEventListener("mouseleave", this.onMouseLeaveBind);
        this.elementListener.removeEventListener("mousemove", this.onMouseMoveBind);
        if (this.gyroscope) window.removeEventListener("deviceorientation", this.onDeviceOrientationBind);
        if (this.glare || this.fullPageListening) window.removeEventListener("resize", this.onWindowResizeBind);
    };
    VanillaTilt.prototype.destroy = function destroy() {
        clearTimeout(this.transitionTimeout);
        if (this.updateCall !== null) cancelAnimationFrame(this.updateCall);
        this.reset();
        this.removeEventListeners();
        this.element.vanillaTilt = null;
        delete this.element.vanillaTilt;
        this.element = null;
    };
    VanillaTilt.prototype.onDeviceOrientation = function onDeviceOrientation(event) {
        if (event.gamma === null || event.beta === null) return;
        this.updateElementPosition();
        if (this.gyroscopeSamples > 0) {
            this.lastgammazero = this.gammazero;
            this.lastbetazero = this.betazero;
            if (this.gammazero === null) {
                this.gammazero = event.gamma;
                this.betazero = event.beta;
            } else {
                this.gammazero = (event.gamma + this.lastgammazero) / 2;
                this.betazero = (event.beta + this.lastbetazero) / 2;
            }
            this.gyroscopeSamples -= 1;
        }
        var totalAngleX = this.settings.gyroscopeMaxAngleX - this.settings.gyroscopeMinAngleX;
        var totalAngleY = this.settings.gyroscopeMaxAngleY - this.settings.gyroscopeMinAngleY;
        var degreesPerPixelX = totalAngleX / this.width;
        var degreesPerPixelY = totalAngleY / this.height;
        var angleX = event.gamma - (this.settings.gyroscopeMinAngleX + this.gammazero);
        var angleY = event.beta - (this.settings.gyroscopeMinAngleY + this.betazero);
        var posX = angleX / degreesPerPixelX;
        var posY = angleY / degreesPerPixelY;
        if (this.updateCall !== null) cancelAnimationFrame(this.updateCall);
        this.event = {
            clientX: posX + this.left,
            clientY: posY + this.top
        };
        this.updateCall = requestAnimationFrame(this.updateBind);
    };
    VanillaTilt.prototype.onMouseEnter = function onMouseEnter() {
        this.updateElementPosition();
        this.element.style.willChange = "transform";
        this.setTransition();
    };
    VanillaTilt.prototype.onMouseMove = function onMouseMove(event) {
        if (this.updateCall !== null) cancelAnimationFrame(this.updateCall);
        this.event = event;
        this.updateCall = requestAnimationFrame(this.updateBind);
    };
    VanillaTilt.prototype.onMouseLeave = function onMouseLeave() {
        this.setTransition();
        if (this.settings.reset) requestAnimationFrame(this.resetBind);
    };
    VanillaTilt.prototype.reset = function reset() {
        this.event = {
            clientX: this.left + this.width / 2,
            clientY: this.top + this.height / 2
        };
        if (this.element && this.element.style) this.element.style.transform = "perspective(" + this.settings.perspective + "px) " + "rotateX(0deg) " + "rotateY(0deg) " + "scale3d(1, 1, 1)";
        this.resetGlare();
    };
    VanillaTilt.prototype.resetGlare = function resetGlare() {
        if (this.glare) {
            this.glareElement.style.transform = "rotate(180deg) translate(-50%, -50%)";
            this.glareElement.style.opacity = "0";
        }
    };
    VanillaTilt.prototype.updateInitialPosition = function updateInitialPosition() {
        if (this.settings.startX === 0 && this.settings.startY === 0) return;
        this.onMouseEnter();
        if (this.fullPageListening) this.event = {
            clientX: (this.settings.startX + this.settings.max) / (2 * this.settings.max) * this.clientWidth,
            clientY: (this.settings.startY + this.settings.max) / (2 * this.settings.max) * this.clientHeight
        };
        else this.event = {
            clientX: this.left + (this.settings.startX + this.settings.max) / (2 * this.settings.max) * this.width,
            clientY: this.top + (this.settings.startY + this.settings.max) / (2 * this.settings.max) * this.height
        };
        var backupScale = this.settings.scale;
        this.settings.scale = 1;
        this.update();
        this.settings.scale = backupScale;
        this.resetGlare();
    };
    VanillaTilt.prototype.getValues = function getValues() {
        var x = void 0, y = void 0;
        if (this.fullPageListening) {
            x = this.event.clientX / this.clientWidth;
            y = this.event.clientY / this.clientHeight;
        } else {
            x = (this.event.clientX - this.left) / this.width;
            y = (this.event.clientY - this.top) / this.height;
        }
        x = Math.min(Math.max(x, 0), 1);
        y = Math.min(Math.max(y, 0), 1);
        var tiltX = (this.reverse * (this.settings.max - x * this.settings.max * 2)).toFixed(2);
        var tiltY = (this.reverse * (y * this.settings.max * 2 - this.settings.max)).toFixed(2);
        var angle = Math.atan2(this.event.clientX - (this.left + this.width / 2), -(this.event.clientY - (this.top + this.height / 2))) * (180 / Math.PI);
        return {
            tiltX: tiltX,
            tiltY: tiltY,
            percentageX: x * 100,
            percentageY: y * 100,
            angle: angle
        };
    };
    VanillaTilt.prototype.updateElementPosition = function updateElementPosition() {
        var rect = this.element.getBoundingClientRect();
        this.width = this.element.offsetWidth;
        this.height = this.element.offsetHeight;
        this.left = rect.left;
        this.top = rect.top;
    };
    VanillaTilt.prototype.update = function update() {
        var values = this.getValues();
        this.element.style.transform = "perspective(" + this.settings.perspective + "px) " + "rotateX(" + (this.settings.axis === "x" ? 0 : values.tiltY) + "deg) " + "rotateY(" + (this.settings.axis === "y" ? 0 : values.tiltX) + "deg) " + "scale3d(" + this.settings.scale + ", " + this.settings.scale + ", " + this.settings.scale + ")";
        if (this.glare) {
            this.glareElement.style.transform = "rotate(" + values.angle + "deg) translate(-50%, -50%)";
            this.glareElement.style.opacity = "" + values.percentageY * this.settings["max-glare"] / 100;
        }
        this.element.dispatchEvent(new CustomEvent("tiltChange", {
            "detail": values
        }));
        this.updateCall = null;
    };
    /**
   * Appends the glare element (if glarePrerender equals false)
   * and sets the default style
   */ VanillaTilt.prototype.prepareGlare = function prepareGlare() {
        // If option pre-render is enabled we assume all html/css is present for an optimal glare effect.
        if (!this.glarePrerender) {
            // Create glare element
            var jsTiltGlare = document.createElement("div");
            jsTiltGlare.classList.add("js-tilt-glare");
            var jsTiltGlareInner = document.createElement("div");
            jsTiltGlareInner.classList.add("js-tilt-glare-inner");
            jsTiltGlare.appendChild(jsTiltGlareInner);
            this.element.appendChild(jsTiltGlare);
        }
        this.glareElementWrapper = this.element.querySelector(".js-tilt-glare");
        this.glareElement = this.element.querySelector(".js-tilt-glare-inner");
        if (this.glarePrerender) return;
        Object.assign(this.glareElementWrapper.style, {
            "position": "absolute",
            "top": "0",
            "left": "0",
            "width": "100%",
            "height": "100%",
            "overflow": "hidden",
            "pointer-events": "none",
            "border-radius": "inherit"
        });
        Object.assign(this.glareElement.style, {
            "position": "absolute",
            "top": "50%",
            "left": "50%",
            "pointer-events": "none",
            "background-image": "linear-gradient(0deg, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 100%)",
            "transform": "rotate(180deg) translate(-50%, -50%)",
            "transform-origin": "0% 0%",
            "opacity": "0"
        });
        this.updateGlareSize();
    };
    VanillaTilt.prototype.updateGlareSize = function updateGlareSize() {
        if (this.glare) {
            var glareSize = (this.element.offsetWidth > this.element.offsetHeight ? this.element.offsetWidth : this.element.offsetHeight) * 2;
            Object.assign(this.glareElement.style, {
                "width": glareSize + "px",
                "height": glareSize + "px"
            });
        }
    };
    VanillaTilt.prototype.updateClientSize = function updateClientSize() {
        this.clientWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        this.clientHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
    };
    VanillaTilt.prototype.onWindowResize = function onWindowResize() {
        this.updateGlareSize();
        this.updateClientSize();
    };
    VanillaTilt.prototype.setTransition = function setTransition() {
        var _this = this;
        clearTimeout(this.transitionTimeout);
        this.element.style.transition = this.settings.speed + "ms " + this.settings.easing;
        if (this.glare) this.glareElement.style.transition = "opacity " + this.settings.speed + "ms " + this.settings.easing;
        this.transitionTimeout = setTimeout(function() {
            _this.element.style.transition = "";
            if (_this.glare) _this.glareElement.style.transition = "";
        }, this.settings.speed);
    };
    /**
   * Method return patched settings of instance
   * @param {boolean} settings.reverse - reverse the tilt direction
   * @param {number} settings.max - max tilt rotation (degrees)
   * @param {startX} settings.startX - the starting tilt on the X axis, in degrees. Default: 0
   * @param {startY} settings.startY - the starting tilt on the Y axis, in degrees. Default: 0
   * @param {number} settings.perspective - Transform perspective, the lower the more extreme the tilt gets
   * @param {string} settings.easing - Easing on enter/exit
   * @param {number} settings.scale - 2 = 200%, 1.5 = 150%, etc..
   * @param {number} settings.speed - Speed of the enter/exit transition
   * @param {boolean} settings.transition - Set a transition on enter/exit
   * @param {string|null} settings.axis - What axis should be enabled. Can be "x" or "y"
   * @param {boolean} settings.glare - if it should have a "glare" effect
   * @param {number} settings.max-glare - the maximum "glare" opacity (1 = 100%, 0.5 = 50%)
   * @param {boolean} settings.glare-prerender - false = VanillaTilt creates the glare elements for you, otherwise
   * @param {boolean} settings.full-page-listening - If true, parallax effect will listen to mouse move events on the whole document, not only the selected element
   * @param {string|object} settings.mouse-event-element - String selector or link to HTML-element what will be listen mouse events
   * @param {boolean} settings.reset - false = If the tilt effect has to be reset on exit
   * @param {gyroscope} settings.gyroscope - Enable tilting by deviceorientation events
   * @param {gyroscopeSensitivity} settings.gyroscopeSensitivity - Between 0 and 1 - The angle at which max tilt position is reached. 1 = 90deg, 0.5 = 45deg, etc..
   * @param {gyroscopeSamples} settings.gyroscopeSamples - How many gyroscope moves to decide the starting position.
   */ VanillaTilt.prototype.extendSettings = function extendSettings(settings) {
        var defaultSettings = {
            reverse: false,
            max: 15,
            startX: 0,
            startY: 0,
            perspective: 1000,
            easing: "cubic-bezier(.03,.98,.52,.99)",
            scale: 1,
            speed: 300,
            transition: true,
            axis: null,
            glare: false,
            "max-glare": 1,
            "glare-prerender": false,
            "full-page-listening": false,
            "mouse-event-element": null,
            reset: true,
            gyroscope: true,
            gyroscopeMinAngleX: -45,
            gyroscopeMaxAngleX: 45,
            gyroscopeMinAngleY: -45,
            gyroscopeMaxAngleY: 45,
            gyroscopeSamples: 10
        };
        var newSettings = {};
        for(var property in defaultSettings){
            if (property in settings) newSettings[property] = settings[property];
            else if (this.element.hasAttribute("data-tilt-" + property)) {
                var attribute = this.element.getAttribute("data-tilt-" + property);
                try {
                    newSettings[property] = JSON.parse(attribute);
                } catch (e) {
                    newSettings[property] = attribute;
                }
            } else newSettings[property] = defaultSettings[property];
        }
        return newSettings;
    };
    VanillaTilt.init = function init(elements, settings) {
        if (elements instanceof Node) elements = [
            elements
        ];
        if (elements instanceof NodeList) elements = [].slice.call(elements);
        if (!(elements instanceof Array)) return;
        elements.forEach(function(element) {
            if (!("vanillaTilt" in element)) element.vanillaTilt = new VanillaTilt(element, settings);
        });
    };
    return VanillaTilt;
}();
if (typeof document !== "undefined") {
    /* expose the class to window */ window.VanillaTilt = $061d6f05ab78f897$var$VanillaTilt;
    /**
   * Auto load
   */ $061d6f05ab78f897$var$VanillaTilt.init(document.querySelectorAll("[data-tilt]"));
}
$061d6f05ab78f897$exports = $061d6f05ab78f897$var$VanillaTilt;



var $iqBwt = parcelRequire("iqBwt");
// Helper: Create element with attributes and classes
function $511f808df98c50dd$var$createElement(tag, { attributes: attributes = {}, classes: classes = [], text: text = "" } = {}) {
    const el = document.createElement(tag);
    Object.entries(attributes).forEach(([key, value])=>el.setAttribute(key, value));
    if (classes.length) el.classList.add(...classes);
    if (text) el.textContent = text;
    return el;
}
// Create post card element
function $511f808df98c50dd$var$createPostCard(post, slug) {
    const { title: title, publishedAt: publishedAt, heroImageUrl: heroImageUrl } = post;
    const card = $511f808df98c50dd$var$createElement("div", {
        classes: [
            "card",
            "rounded",
            "h-100",
            "js-tilt"
        ],
        attributes: {
            "data-tilt": "",
            "data-tilt-max": "4",
            "data-tilt-glare": "true",
            "data-tilt-max-glare": "0.5"
        }
    });
    // Image setup with fallback
    const img = $511f808df98c50dd$var$createElement("img", {
        attributes: {
            src: heroImageUrl || "./assets/images/fingers-sm.jpg",
            alt: `Cover image for ${title}`,
            style: "height: 200px; object-fit: cover;"
        }
    });
    card.appendChild(img);
    // Description setup
    const desc = $511f808df98c50dd$var$createElement("div", {
        classes: [
            "desc"
        ]
    });
    desc.appendChild($511f808df98c50dd$var$createElement("h3", {
        text: title || "Untitled Post"
    }));
    let displayDate = "";
    if (publishedAt) {
        const dateObj = publishedAt.toDate ? publishedAt.toDate() : new Date(publishedAt);
        displayDate = dateObj.toLocaleDateString(undefined, {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        });
    }
    if (displayDate) desc.appendChild($511f808df98c50dd$var$createElement("p", {
        classes: [
            "post-date"
        ],
        text: `Published: ${displayDate}`
    }));
    card.appendChild(desc);
    // Link wrapper
    const isLocalhost = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";
    const postLink = slug ? isLocalhost ? `./blog/post.html?slug=${slug}` : `./blog/${slug}` : "#";
    const link = $511f808df98c50dd$var$createElement("a", {
        classes: [
            "col",
            "d-flex",
            "blog-wrapper__card",
            "load-hidden"
        ],
        attributes: {
            href: postLink
        }
    });
    link.appendChild(card);
    return link;
}
// Create "Discover more" card
function $511f808df98c50dd$var$createReadMoreCard() {
    // Create main card wrapper
    const card = $511f808df98c50dd$var$createElement("div", {
        classes: [
            "card",
            "read-more-card",
            "rounded",
            "h-100",
            "w-100",
            "js-tilt"
        ],
        attributes: {
            "data-tilt": "",
            "data-tilt-max": "4",
            "data-tilt-glare": "true",
            "data-tilt-max-glare": "0.5"
        }
    });
    // Add arrow container
    const arrowContainer = $511f808df98c50dd$var$createElement("div", {
        classes: [
            "arrow-container"
        ]
    });
    arrowContainer.innerHTML = `
    <svg class="arrow-right" viewBox="0 0 24 24" width="64" height="64" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <line x1="5" y1="12" x2="19" y2="12"></line>
      <polyline points="12 5 19 12 12 19"></polyline>
    </svg>
  `;
    card.appendChild(arrowContainer);
    // Add description div
    const desc = $511f808df98c50dd$var$createElement("div", {
        classes: [
            "desc"
        ]
    });
    desc.appendChild($511f808df98c50dd$var$createElement("h3", {
        text: "Discover more blog posts"
    }));
    card.appendChild(desc);
    // Create the anchor wrapper
    const link = $511f808df98c50dd$var$createElement("a", {
        classes: [
            "col",
            "d-flex",
            "blog-wrapper__card",
            "load-hidden"
        ],
        attributes: {
            href: "./blog/index.html"
        }
    });
    link.appendChild(card);
    return link;
}
// Initialize tilt effect
function $511f808df98c50dd$var$initTiltOnElements() {
    if (window.VanillaTilt) (0, (/*@__PURE__*/$parcel$interopDefault($061d6f05ab78f897$exports))).init(document.querySelectorAll(".js-tilt"));
}
// Fetch and render posts from Firestore
async function $511f808df98c50dd$var$fetchAndRenderPosts() {
    const blogPosts = document.getElementById("blogPosts");
    if (!blogPosts) {
        console.error("Blog posts container not found!");
        return;
    }
    blogPosts.innerHTML = "<p>Loading blog posts...</p>";
    try {
        if (!(0, $iqBwt.db)) throw new Error("Firestore database is not configured. Ensure Firebase is initialized.");
        const querySnapshot = await (0, $iqBwt.db).collection("posts").where("status", "==", "published").orderBy("publishedAt", "desc").limit(3).get();
        const fragment = document.createDocumentFragment();
        querySnapshot.forEach((docSnap)=>{
            try {
                const postElement = $511f808df98c50dd$var$createPostCard(docSnap.data(), docSnap.id);
                fragment.appendChild(postElement);
            } catch (error) {
                console.error("Error creating post card:", error);
            }
        });
        const readMoreCard = $511f808df98c50dd$var$createReadMoreCard();
        fragment.appendChild(readMoreCard);
        blogPosts.innerHTML = "";
        blogPosts.appendChild(fragment);
        $511f808df98c50dd$var$initTiltOnElements();
        (0, $879a1b32f60b3418$export$2e2bcd8739ae039)((0, $5912c15f3759d7b5$export$adcf75ad64a03007), (0, $5912c15f3759d7b5$export$9c21a3269931e1e6));
    } catch (error) {
        console.error("Error fetching blog posts from Firestore:", error);
        blogPosts.innerHTML = `
      <div class="error-message p-3 border rounded text-center">
        <p>Failed to load blog posts. Please try again later.</p>
        <p class="error-details small text-muted">${error.message}</p>
      </div>
    `;
    }
}
// Navigation toggle
function $511f808df98c50dd$var$toggleMenu() {
    const nav = document.querySelector(".Navbar__Items");
    const icon = document.querySelector(".Navbar__Link-toggle i");
    nav.classList.toggle("Navbar__ToggleShow");
    icon?.classList.toggle("toggle", nav.classList.contains("Navbar__ToggleShow"));
}
// Initialize everything
document.addEventListener("DOMContentLoaded", ()=>{
    $511f808df98c50dd$var$fetchAndRenderPosts();
    (0, $879a1b32f60b3418$export$2e2bcd8739ae039)((0, $5912c15f3759d7b5$export$adcf75ad64a03007), (0, $5912c15f3759d7b5$export$9c21a3269931e1e6));
    document.querySelector(".Navbar__Link-toggle").addEventListener("click", $511f808df98c50dd$var$toggleMenu);
});


//# sourceMappingURL=repo.d30eb753.js.map
